var _path, _path2, _path3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SolomonIslandsCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0d47a1",
    d: "M3.989,24c0,3.889,1.128,7.507,3.048,10.578l34.265-20.559C37.846,8.036,31.396,4,23.989,4 C12.944,4,3.989,12.954,3.989,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M42.758,17.145c-0.398-1.09-0.882-2.135-1.455-3.127L7.038,34.578 c0.613,0.98,1.306,1.899,2.074,2.755L42.758,17.145z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M23.989,44c11.046,0,20-8.954,20-20c0-2.412-0.449-4.714-1.231-6.855L9.112,37.333 C12.774,41.416,18.073,44,23.989,44z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "14.159,8.569 14.715,10.209 16.447,10.231 15.058,11.266 15.573,12.92 14.159,11.919 12.746,12.92 13.261,11.266 11.872,10.231 13.604,10.209"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "19.053,12.757 19.609,14.397 21.34,14.418 19.952,15.454 20.467,17.107 19.053,16.107 17.64,17.107 18.154,15.454 16.766,14.418 18.498,14.397"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "23.947,8.569 24.503,10.209 26.234,10.231 24.846,11.266 25.36,12.92 23.947,11.919 22.533,12.92 23.048,11.266 21.66,10.231 23.391,10.209"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "14.159,17.045 14.715,18.685 16.447,18.707 15.058,19.742 15.573,21.395 14.159,20.395 12.746,21.395 13.261,19.742 11.872,18.707 13.604,18.685"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "23.947,17.045 24.503,18.685 26.234,18.707 24.846,19.742 25.36,21.395 23.947,20.395 22.533,21.395 23.048,19.742 21.66,18.707 23.391,18.685"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SolomonIslandsCircular);
export default __webpack_public_path__ + "static/media/icons8-solomon-islands-circular.567d7a5ed4788531d56519ecc504c8f2.svg";
export { ForwardRef as ReactComponent };